exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-status-header{margin-top:20px;margin-bottom:20px}.user-status-header .user-status-resume{float:left;width:calc(100% - 300px);margin-bottom:20px}.user-status-header .user-status-search{clear:both}.user-card-header{margin-top:20px;margin-bottom:20px}.user-card-header .user-card-resume{float:left;width:calc(100% - 300px);margin-bottom:20px}.user-card-header .user-card-search{clear:both}.user-enrollment-header{margin-top:20px;margin-bottom:20px}.user-enrollment-header .user-enrollment-resume{float:left;width:calc(100% - 300px);margin-bottom:20px}.user-enrollment-header .user-enrollment-search{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/main/webapp/app/admin/user-management/css/user-management-detail.scss
// module id = 876
// module chunks = 0